"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IProfile } from "@/interfaces/permission.interfaces";
import permissionService from "@/services/permissions.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAllProfilesReturn = RequestsBaseReturn<PaginatedResponse<IProfile> | null>;

export interface UseGetAllProfilesProps extends RequestPagination {}

type GetAllSwrParams = [string, number, number];

const useGetAllProfiles = (props?: UseGetAllProfilesProps): UseGetAllProfilesReturn => {
  const { pageNumber = 1, pageSize = 100 } = props || {};
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IProfile>, Error, GetAllSwrParams>(
    [SWR_KEYS.getAllProfiles, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      permissionService.getAllProfiles({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetAllProfiles;
